export const funcCheckStatusProject = status => {
  let resStatus = ''
  switch (status) {
    case 1:
      {
        resStatus = 'Draft'
      }
      break
    case 2:
      {
        resStatus = 'WIP'
      }
      break
    case 3:
      {
        resStatus = 'Cancelled'
      }
      break
    case 4:
      {
        resStatus = 'Completed'
      }
      break
    default:
      break
  }
  return resStatus
}
